module.exports = __webpack_public_path__ + "img/JT-7-4-3-5Us-no60.d8f895c4.jpg";